import type { ChiefNoteDTO } from "@roomate/core";

const round2 = (n: number) => Math.round(n * 100) / 100;

/**
 * The Chief's note as one line above a decision's options (chief-of-office.md C20-AC1). Never null for a
 * note: a facts-only note (review_change, spot_check) still reads "Chief (agent) note" and its facts follow.
 */
export function chiefNoteLine(note: Pick<ChiefNoteDTO, "recommendation" | "confidence">): string {
  const rec = note.recommendation?.trim();
  const conf = note.confidence != null ? `confidence ${round2(note.confidence)}` : "";
  if (rec) return `Chief (agent) recommends ${rec}${conf ? `, ${conf}` : ""}`;
  return conf ? `Chief (agent) note, ${conf}` : "Chief (agent) note";
}

/** An in-app path only: one leading slash, no backslash (browsers read `/\host` as `//host`), no control characters. */
export const isInternalRef = (ref: string): boolean => /^\/(?![/\\])/.test(ref) && !/[\\\u0000-\u001f]/.test(ref);

/** The option ids a surface offers for a decision: always the decision's own list, the one the answer endpoint accepts (C16-AC2). */
export const optionIds = (d: { options: readonly { id: string }[] }): string[] => d.options.map((o) => o.id);
